import {
	Component,
	OnInit,
	Inject,
	Optional,
	ChangeDetectionStrategy,
} from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-ec-modal',
	templateUrl: './ec-modal.component.html',
	styleUrls: ['./ec-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		MatDialogTitle,
		CdkScrollable,
		MatDialogContent,
		MatDialogActions,
		MatButton,
		MatDialogClose,
	],
})
export class ECModalComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<ECModalComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any
	) {
		dialogRef.disableClose = true;
	}

	ngOnInit(): void {}

	onCancel() {
		this.dialogRef.close(false);
	}
	onConfirm() {
		this.dialogRef.close(true);
	}
}
